<script lang="ts">
import { onDestroy, onMount } from "svelte";
import type { Question } from "../Model/Question";
import type { Resume } from "../Model/Resume";
import { questionsService, answersService } from "../services";

type QuestionAnswers = {
  question: Question,
  answers: Resume
}

let questionAnswers: QuestionAnswers[] = [];
let viewOptions: Boolean = true;
let loadTimeOut: number;

onMount(() => {
  // const passWord = prompt('contraseña');
  
  // if (passWord != 'quimera159') {
  //   return
  // }

  loadQuestions();

})

onDestroy(() => {
  window.clearTimeout(loadTimeOut);
})

async function loadQuestions(){
  try {
    const [questions, resumes] = await Promise.all([
      questionsService.findQuestions(),
      answersService.findResume()
    ])

    let totalNum: number = 0;

    for (const resume of resumes) {
      totalNum = totalNum + resume.votes;
    }

    for (const resume of resumes) {
      resume.votes = Math.round((resume.votes * 100) / totalNum);
    }

    questionAnswers = questions.map(question => ({
      question,
      answers: resumes.find(({ questionId }) => questionId == question.id)
    }))
  } finally{
    loadTimeOut = window.setTimeout(loadQuestions, 5000);
  }

}


</script>

<style lang="scss">

.body-html {
    height: 100%;
      display: flex;
      align-items: center;
      padding-top: 40px;
      padding-bottom: 40px;
      max-width: 360px;
      margin: auto;
  }


  img{
    width: 60%;
    height: auto;
  }

  .img-icon{
    max-width: 70px;
    margin-bottom: 30px;
  }

  .font-tittle{
    color: white;
    font-size: 45px;
  }

  .second-tittle{
        font-family: 'Lato', sans-serif !important;
        color: #FEB531;
        font-size: 18px;
        font-style: italic;
    }

    .box-question{
    display: flex;
    flex-direction: row;
    align-items: center;
    border: 0.5rem solid #CF2F2C;
    background-color: #CF2F2C;
    border-radius: 1rem;
    margin-bottom: 1.5rem;
    height: 100px;

    .third-tittle{
      font-weight: bold;
      margin: auto;
    }
  }

  .button-opcion{
    width: 100%;
    height: 150px;
    margin-bottom: 20px;
    color: white;
    font-size: 30px;
  }

  hr{
        color: #FFFFFF;
        max-width: 242px;
        margin: auto;
        opacity: 1;
        margin-bottom: 50px;
        margin-top: 50px;
        height: 1px;
    }

</style>

  <div class="body-html">
    <div class="container">
      <div class="row">
  
        {#if questionAnswers && viewOptions}  
          <div class="mb-3 col-12 text-center">
            <h1 class="mb-3 font-tittle">Resultados</h1>
          </div>
          {#each questionAnswers as {question, answers} }

            <div class="col-12 text-center">
              <div class="box-question" style="background-color: {question.color}; border-color: {question.color}; color: {question.color}">
                <span class="third-tittle" style="color: {question.textColor}">{question.name} / {answers?.votes ? answers.votes : 0}%</span>
              </div>
            </div>

<!-- 
            <div class="col-12 text-center">
              <button class="button-opcion" style="background-image: url('img/{question.imagen}')">
                {question.name} / {answers.length}
              </button>
            </div> -->
          {/each}
        {/if}

      </div>
    
     
  
  
    </div>
  </div>
